const STORAGE_KEY = "tessera.strategyRd.coachPanelWidth";

export const STRATEGY_RD_COACH_WIDTH_MIN = 280;
export const STRATEGY_RD_COACH_WIDTH_DEFAULT_RATIO = 0.3;
export const STRATEGY_RD_COACH_WIDTH_MAX_RATIO = 0.7;

export function clampStrategyRdCoachWidth(
  width: number,
  hostWidth: number
): number {
  if (!(hostWidth > 0)) {
    return Math.max(STRATEGY_RD_COACH_WIDTH_MIN, Math.round(width));
  }
  const max = Math.max(
    STRATEGY_RD_COACH_WIDTH_MIN,
    Math.floor(hostWidth * STRATEGY_RD_COACH_WIDTH_MAX_RATIO)
  );
  const min = Math.min(STRATEGY_RD_COACH_WIDTH_MIN, max);
  return Math.min(max, Math.max(min, Math.round(width)));
}

export function defaultStrategyRdCoachWidth(hostWidth: number): number {
  if (!(hostWidth > 0)) return 420;
  return clampStrategyRdCoachWidth(
    hostWidth * STRATEGY_RD_COACH_WIDTH_DEFAULT_RATIO,
    hostWidth
  );
}

export function readStrategyRdCoachWidth(hostWidth: number): number {
  if (typeof window === "undefined") return defaultStrategyRdCoachWidth(hostWidth);
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw == null) return defaultStrategyRdCoachWidth(hostWidth);
    const n = Number(raw);
    if (!Number.isFinite(n)) return defaultStrategyRdCoachWidth(hostWidth);
    return clampStrategyRdCoachWidth(n, hostWidth);
  } catch {
    return defaultStrategyRdCoachWidth(hostWidth);
  }
}

export function writeStrategyRdCoachWidth(width: number): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, String(Math.round(width)));
  } catch {
    /* ignore quota */
  }
}
